import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  var _a;
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { o365ThrottleEnabled, o365StoreFullMessage, timeoutGracePeriodMinutes } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(ThrottlingCheckbox, { id: "o365ThrottleEnabled", defaultChecked: o365ThrottleEnabled == null ? void 0 : o365ThrottleEnabled.value, onChange }), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "o365StoreFullMessage",
      type: "checkbox",
      value: "enable-storeFullMessage",
      defaultChecked: o365StoreFullMessage == null ? void 0 : o365StoreFullMessage.value,
      onChange,
      label: "Store Full Message",
      help: "Store the full original Office 365 log record message as full_message?"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "timeoutGracePeriodMinutes",
      type: "number",
      min: "1",
      value: (_a = timeoutGracePeriodMinutes == null ? void 0 : timeoutGracePeriodMinutes.value) != null ? _a : "",
      onChange,
      label: "Timeout Grace Period (minutes)",
      help: "How long repeated Office 365 timeouts must continue before the input is marked as failing."
    }
  ));
};
export default FormAdvancedOptions;
